<script>
  import {update_video_and_state} from "./Utils/RouterUtils.svelte"
  export let video = null;
  export let category = null;
  export let playlist = null;
  export let project = null;
  function handleClick() {
      update_video_and_state( category, playlist, project, video )
  }
</script>
<a on:click={handleClick}>
  <slot></slot>
</a>
